/**
 * A reload of the conversation from the server must not erase what is
 * still on its way there.
 *
 * On every reconnect the open chat was replaced wholesale by the server's
 * page. A message still in the send queue — written down, encrypted, waiting
 * for its chat_sent — is not on that page yet, so it vanished from the
 * screen; when the acknowledgement came a moment later there was nothing to
 * reconcile it with, and the message reappeared only at the next opening of
 * the chat (iPhone, Wi-Fi → cellular, 2026-09-02). Meanwhile the peer had
 * it. The sender saw their own message disappear.
 *
 * Rule: rows that are awaiting (pending, held, retrying) and absent from the
 * fetched page — by our client id, or by server id — stay on screen, after
 * the page, in the order they were composed.
 */
const midOf = (m) => m.clientMid || m.client_mid || null;
export const isAwaiting = (m) => !!(m && (m._pending || m.sendError === 'E_UNTRUSTED' || m.sendError === 'E_RETRY'));

export function keepUnacknowledged(prev, fetched) {
  const page = Array.isArray(fetched) ? fetched : [];
  const mids = new Set(page.map(midOf).filter(Boolean));
  const ids = new Set(page.map(m => m.id).filter(Boolean));
  const kept = (prev || []).filter(m => isAwaiting(m) && !(midOf(m) && mids.has(midOf(m))) && !(m.id && ids.has(m.id)));
  return kept.length ? [...page, ...kept] : page;
}
